import { ResidentListProcessDialogShell } from './ResidentListProcessDialogShell'

export interface ResidentListPaidConfirmDialogProps {
  isOpen: boolean
  title: string
  subtitle?: string
  message: string
  primaryLabel: string
  secondaryLabel: string
  onPrimary: () => void | Promise<void>
  onSecondary: () => void | Promise<void>
  onDismiss: () => void
}

export function ResidentListPaidConfirmDialog({
  isOpen,
  title,
  subtitle,
  message,
  primaryLabel,
  secondaryLabel,
  onPrimary,
  onSecondary,
  onDismiss,
}: ResidentListPaidConfirmDialogProps) {
  return (
    <ResidentListProcessDialogShell
      isOpen={isOpen}
      title={title}
      subtitle={subtitle}
      onClose={onDismiss}
      overlayDataTestId="resident-list-paid-confirm-overlay"
      panelDataTestId="resident-list-paid-confirm-panel"
      bodyDataTestId="resident-list-paid-confirm-body"
      footerDataTestId="resident-list-paid-confirm-footer"
      closeButtonDataTestId="resident-list-paid-confirm-close-button"
      titleId="resident-list-paid-confirm-title"
      subtitleDataTestId="resident-list-paid-confirm-subtitle"
      footer={
        <>
          <button
            type="button"
            onClick={() => void onSecondary()}
            data-testid="resident-list-paid-confirm-secondary-button"
            className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 sm:w-auto"
          >
            {secondaryLabel}
          </button>
          <button
            type="button"
            onClick={() => void onPrimary()}
            data-testid="resident-list-paid-confirm-primary-button"
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700 sm:w-auto"
          >
            {primaryLabel}
          </button>
        </>
      }
    >
      <div className="whitespace-pre-line rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm font-medium leading-6 text-slate-700">
        {message}
      </div>
    </ResidentListProcessDialogShell>
  )
}
